import React from 'react';
import { useKeenSlider } from 'keen-slider/react.js';
import { UpsellItem } from 'data-types';
import * as translator from '../../../../../utils/translator';
import CareProfileCard from './CareProfileCard';
import UpsellProductCard from './UpsellProductCard';



interface UpsellBlockProps {
	title: string | null;
	items: UpsellItem[];
	language: string;
}

const UpsellBlock: React.FC<UpsellBlockProps> = ({ title, items, language }) => {
	const [sliderRef] = useKeenSlider<HTMLDivElement>({
		mode: 'free-snap',
		renderMode: 'performance',
		rubberband: true,
		slides: {
			perView: 'auto',
			spacing: 7,
		},
	});

	if (items.length === 0) {
		return null;
	}

	return (
		<CareProfileCard id="care-profile-upsell-block" className="flex flex-col gap-y-3">
			{title && (
				<div className="flex items-center gap-x-2">
					<p className="text-base font-semibold text-care-plus-heading">{translator.translate(language, 'my_account', title)}</p>
					<span className="bg-[#faf4ef] text-[#e88103] text-[10px] font-bold leading-[15px] px-[9px] py-[2px] rounded">SHOP</span>
				</div>
			)}

			<div id="care-profile-upsell-carousel" ref={sliderRef} className="keen-slider flex overflow-hidden">
				{items.map((item) => (
					<UpsellProductCard key={item.productItemID} item={item} language={language} />
				))}
			</div>
		</CareProfileCard>
	);
};

export default UpsellBlock;
